<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-base-evgGoodsCombine',
  components: {
    PageTable,
  },
}
</script>
